/*
Licensed Materials - Property of IBM
694906H
(c) Copyright IBM Corp.  2020 All Rights Reserved

US Government Users Restricted Rights - Use, duplication or disclosure restricted
by GSA ADP Schedule Contract with IBM Corp.
*/

import { useLazyQuery, gql } from '@apollo/client';

const FETCH_TD_LOGIN_CONFIG_URL = gql`
query Configuration($inputKeys: [String!]!) {
  configuration(inputKeys: $inputKeys) {
    name
    value
  }
}
`;
export const  useFetchTDLoginConfig =  () => {
  const [getTdConfigDetails, TdConfigDetail] = useLazyQuery(FETCH_TD_LOGIN_CONFIG_URL,{fetchPolicy:'network-only',context:{clientName:"config"}});
  return { getTdConfigDetails, TdConfigDetail };
};
